import {
  FileCheck2,
  GraduationCap,
  MessagesSquare,
  ShieldCheck
} from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { processSteps } from "../../data/homeData";

const iconMap = {
  counselling: MessagesSquare,
  selection: GraduationCap,
  application: FileCheck2,
  visa: ShieldCheck
};

function JourneySection() {
  return (
    <MotionSection id="journey" className="relative py-20 md:py-28 bg-white/50">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Student Journey"
          title="A Clear 4-Step Path from Planning to Visa Readiness"
          description="Our process is designed to remove confusion and help you move forward with confidence, one well-guided step at a time."
        />

        <div className="relative mt-16 md:mt-24">
          <div className="absolute left-6 top-6 bottom-6 w-px bg-midnight-navy/10 lg:hidden" />
          <div className="hidden lg:block absolute top-[23px] left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-midnight-navy/15 to-transparent" />

          <div className="grid gap-12 lg:grid-cols-4 lg:gap-8 relative z-10">
            {processSteps.map((step, index) => {
              const Icon = iconMap[step.icon];

              return (
                <article
                  key={step.title}
                  className="group relative pl-16 lg:pl-0 lg:pt-16"
                >
                  <div className="absolute left-0 top-0 lg:left-1/2 lg:-translate-x-1/2 flex h-12 w-12 items-center justify-center rounded-full border-4 border-white bg-midnight-navy text-soft-white shadow-[0_4px_12px_rgba(7,18,38,0.12)] transition-transform duration-300 group-hover:scale-110 group-hover:bg-royal-blue">
                    <Icon className="h-5 w-5 text-warm-gold" aria-hidden="true" />
                  </div>
                  
                  <div className="lg:text-center pt-2">
                    <span className="inline-flex text-[10px] font-bold text-royal-blue uppercase tracking-widest bg-royal-blue/10 px-2.5 py-1 rounded-sm mb-2">
                      Phase 0{index + 1}
                    </span>
                    <h3 className="text-xl font-bold leading-tight md:text-2xl text-midnight-navy transition-colors group-hover:text-royal-blue">{step.title}</h3>
                    <p className="mt-2.5 text-sm leading-relaxed text-slate-text/75 mx-auto max-w-[16rem]">
                      {step.description}
                    </p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default JourneySection;
